export const specialApprovalTokens = {
  1: ["0xdac17f958d2ee523a2206206994597c13d831ec7"],
};
